export default function initObfuscateLink() {
    const $obfuscateLink = document.querySelectorAll<HTMLElement>('[data-href]');
    $obfuscateLink.forEach($container => {
        new ObfuscateLink($container);
    });
}


export class ObfuscateLink {
    $el: HTMLElement;
   
    constructor($el: HTMLElement) {
        this.$el = $el;
       
        this.init();
    }

    init() {
        if (!this.$el) {
            return;
        }
        
        this.$el.addEventListener('click', () => {
            const targetUrl = this.$el?.getAttribute('data-href');
            const target = this.$el?.getAttribute('target') || '_self';
            
            if (targetUrl) {
                if (target === '_blank') {
                    window.open(targetUrl, '_blank');
                } else {
                    window.location.href = targetUrl;
                }
            }
        });
    }
}